const landing = {
  title: "Order Domino's Pizza Online. Select your favorite …erts/sides and get the best deals/coupons online.",
  keywords: "Our Menu",
  description: "Order Domino's Pizza Online. Select your favorite …erts/sides and get the best deals/coupons online."
}

const pizza = {
  title: "Order Domino's Pizza Online. Select your favorite …erts/sides and get the best deals/coupons online.",
  keywords: "Our Menu",
  description: "Order Domino's Pizza Online. Select your favorite …erts/sides and get the best deals/coupons online."
}

const loadedPizza = {
  description: "Veg Pizza -Domino's Bangladesh delivers tastiest veg pizza online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
  title: "Order Veg Pizza Online | Domino's Bangladesh",
  keywords: "Veg pizza"
}

const sides = {
  description: "Sides - Domino's Bangladesh delivers tastiest pizza online at best prices. Order Garlic Breadstic, Chicken wings and Get delivered at your doorstep.",
  title: "Order Sides Online | Domino's Bangladesh",
  keywords: "Sides"
}


const bevrages = {
  description: "Beverages - Domino's Bangladesh delivers beverages online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
  title: "Order Beverages Online | Domino's Bangladesh",
  keywords: "Beverages"
}

const Desserts = {
  description: "Desserts - Domino's Bangladesh delivers Desserts online at best prices. Order and Get Veg, Non Veg Pizza delivered at your doorstep.",
  title: "Order Desserts Online | Domino's Bangladesh",
  keywords: "Desserts"
}

/**
 * For now We don't have updated seo tags for specif menu in bangladesh
 * Please update all default [landing] with their corresponding seo value once you have specifc values available
 *
 *  Note:: Please update or delete this comment section once this issue get resolved.
 */

const bangladeshSeoData = {
  '/': landing,

  '/menu/pizza': landing,
  '/menu/50': landing,

  '/menu/loaded-pizza': landing,
  '/menu/52': landing,

  '/menu/sides': landing,
  '/menu/4': landing,

  '/menu/beverages': landing,
  '/menu/5': landing,

  '/menu/desserts': landing,
  '/menu/51': landing,

  '/menu/favourite': landing,
  '/menu/0': landing

};

module.exports = bangladeshSeoData;
